import { render, staticRenderFns } from "./Planejamento.vue?vue&type=template&id=54a4bfb9&"
import script from "./Planejamento.vue?vue&type=script&lang=js&"
export * from "./Planejamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports